import { render, staticRenderFns } from "./CompanyManager.vue?vue&type=template&id=c712d73c"
import script from "./CompanyManager.vue?vue&type=script&lang=js"
export * from "./CompanyManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports